import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { Response } from '@angular/http';
import { Observable } from 'rxjs/Observable';

@Injectable()
export class FileService {
  constructor(private http: HttpClient) {}

  determineLinkType = (url: string) => {
    return this.http.head(url, { observe: 'response' }).map(response => {
      const contentType = response.headers.get('Content-Type').toLowerCase();
      console.log(contentType);
      if (contentType.includes('application/') || contentType.includes('image/') || contentType.includes('video/')) {
        return 'file_link';
      } else if (contentType.includes('text/html')) {
        return 'url_link';
      } else {
        return 'unknown';
      }
    });
  };

  getFileLink = (url: string) => {
    return this.http.get(url, { observe: 'response', responseType: 'blob' });
  };
  postGetFileLink = (url: string, body?: any) => {
    const headers = new HttpHeaders({
      Authorization: localStorage.getItem('Access-Token'),
    });
    console.log(headers);
    return this.http.post(
      environment.api_evs + '/v2/social/stream-file',
      {
        url: url,
        method: 'GET',
      },
      { headers, observe: 'response', responseType: 'blob' }
    );
  };
  getFileExtension = (mimeType: string) => {
    const mimeMap: { [key: string]: string } = {
      'application/pdf': 'pdf',
      'application/msword': 'doc',
      'application/vnd.openxmlformats-officedocument.wordprocessingml.document': 'docx',
      'application/vnd.ms-excel': 'xls',
      'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': 'xlsx',
      'image/png': 'png',
      'image/jpeg': 'jpg',
      'image/gif': 'gif',
      'text/plain': 'txt',
      'application/zip': 'zip',
      'application/x-rar-compressed': 'rar',
      'audio/mpeg': 'mp3',
      'audio/wav': 'wav',
      'video/mp4': 'mp4',
      'video/quicktime': 'mov',
      // Add more mappings as needed
    };
    return mimeMap[mimeType] || 'file';
  };

  downloadFile = (url: string) => {
    return this.http.get(url, { responseType: 'blob' });
  };
}



// WEBPACK FOOTER //
// ./src/app/common/services/File.service.ts